import { useTokenValidation } from './use-token-validation';

export const useAuth = () => {
  useTokenValidation();
};
